import Accordion from "react-bootstrap/Accordion";
import { useAccordionButton } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { IoIosArrowDown } from "react-icons/io";
import './FilterGroupCard.css';

function CustomToggle({ children, eventKey }) {
    const decoratedOnClick = useAccordionButton(eventKey);

    return (
        <button
            type="button"
            className="me-3"
            style={{
                border: "none",
                background: "transparent",
                cursor: "pointer"
            }}
            onClick={decoratedOnClick}
        >
            {children}
        </button>
    );
}

const FilterGroupCard = ({ filter, index, onAddFilter }) => {
    return (
        <>
            <div className="w-100 p-3 my-2 bg-light">
                <div className="d-flex align-items-center">
                    <CustomToggle eventKey={index}>
                        <IoIosArrowDown />
                    </CustomToggle>

                    <div className="w-100 d-flex justify-content-between">
                        <div>
                            <strong>{index + 1}. Filter Type:</strong> {filter.name}
                        </div>
                        <button className="btn btn-sm text-danger">
                            Remove filter group
                        </button>
                    </div>
                </div>

                <Accordion.Collapse eventKey={index}>
                    <Card.Body>
                        <table className="table table-sm align-middle mt-3">
                            <thead className="table-secondary">
                                <tr>
                                    <th>Filter</th>
                                    <th>Image</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filter.filters.length ? (
                                    filter.filters.map(item => (
                                        <tr key={item._id}>
                                            <td>{item.name}</td>
                                            <td>
                                                <img
                                                    src={item.imageUrl}
                                                    alt={item.name}
                                                    style={{
                                                        width: 80,
                                                        height: 80,
                                                        objectFit: "cover"
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <button className="btn btn-sm text-primary me-2">
                                                    Edit
                                                </button>
                                                <button className="btn btn-sm text-danger">
                                                    Remove
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="text-center text-muted">
                                            No filters found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        <button
                            className="btn btn-outline-primary"
                            onClick={() => onAddFilter(index)}
                        >
                            + Add Filter
                        </button>
                    </Card.Body>
                </Accordion.Collapse>
            </div>
        </>
    );
};

export default FilterGroupCard;